export const CONSULTATION_INTAKE_SECTION_ORDER = ['history', 'lifestyle', 'assessment'];
